import { Box, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import React from "react";
import { NavLink } from "react-router-dom";
import PeopleRoundedIcon from "@material-ui/icons/PeopleRounded";
import { useSelector } from "react-redux";
import { MY_SELECTED_TEAM_ } from "header/team-selector/TeamSelector";

export const TeamNavigation: React.FC = () => {
  const teamId = useSelector((state: any) => state?.userManager?.team ?? localStorage.getItem(MY_SELECTED_TEAM_));

  if(!teamId) {
    return null;
  }
  return (
    <NavLink
      className="navigation-tab"
      key={"applications"}
      activeClassName="active"
      to={`/home/teams/${teamId}`}
    >
      <ListItem button>
        <ListItemIcon>
          <PeopleRoundedIcon style={{ color: "#fff" }} />
        </ListItemIcon>
        <ListItemText
          className="sub-menu-text"
          primary={
            <Box display="flex">
              <Box flexGrow={1}>Teams</Box>
            </Box>
          }
        />
      </ListItem>
    </NavLink>
  );
};
